export class QuestionDataFactory {
  static create(value, options = {}) {
    const baseData = { value };

    if (options.languageDetection) {
      return {
        ...baseData,
        languageCode: options.languageCode || null,
        score: options.score ?? null,
      };
    }

    return baseData;
  }

  static isProcessed(data) {
    return data && typeof data === 'object' && 'value' in data;
  }

  static sanitizeValue(value) {
    if (typeof value === 'string') {
      let sanitized = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
      sanitized = sanitized.replace(/<[a-zA-Z/!?][^>]*>/g, '');
      return sanitized.trim();
    }
    return value;
  }
}
